import { NavLink, Outlet } from "react-router-dom";
import "./body.css"
import Header from "./header";
import Footer from "./footer";

import React, { useEffect } from "react";

function Media() {
    useEffect(() => {
        document.title = "Josiah Swanson - Media";
    }, []);
    return (
        <>
            <Header />
            <section className="mainbody">
                <nav style={{ margin: "0 0 55px 0" }} className="specialhorizontalnav">
                    {/* <NavLink className={({ isActive }) => isActive ? "selectedlink" : "notselectedlink"} to="blog">Blog</NavLink> */}
                    {/* <li>
                        <a rel="noreferrer" target="_blank" href="https://beholdchristdaily.com/daily">Behold Christ</a>
                    </li> */}
                    <li>
                        <a rel="noreferrer" target="_blank" href="https://www.instagram.com/biblelegos/">LEGOs</a>
                    </li>
                    <li>
                        <NavLink className={({ isActive }) => isActive ? "selectedlink" : "notselectedlink"} to="photos">Photos</NavLink>
                    </li>
                    <li>
                        <NavLink className={({ isActive }) => isActive ? "selectedlink" : "notselectedlink"} to="essays">Essays</NavLink>
                    </li>
                    <li>
                        <NavLink className={({ isActive }) => isActive ? "selectedlink" : "notselectedlink"} to="iwk">Invest with Knowledge!</NavLink>
                    </li>
                    <li>
                        <a rel="noreferrer" target="_blank" href="https://bibletrivia.josiahswanson.com">Bible Trivia</a>
                    </li>
                </nav>
                <Outlet />
            </section>
            <Footer />
        </>
    );
}

export default Media;
